// react
import React from 'react';

import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { userService } from '../../services/user.service';

// application
import Dropdown from './Dropdown';


function Topbar(props) {

    const { username }  = userService.getUser();

    const links = [
        { title: <FormattedMessage id="topbar.herramientas" defaultMessage="Herramientas" />, url: '/clinica/app' }
    ];

    const accountLinks = [
        { title: 'Cambiar contraseña', url: '/account/password' },
        { title: 'Salir', url: '/account/logout' },
    ];

    const linksList = links.map((item, index) => (
        <div key={index} className="topbar__item topbar__item--link">
            <Link className="topbar-link" to={item.url}>{item.title}</Link>
        </div>
    ));


    return (
        <div className="site-header__topbar topbar">
            <div className="topbar__container container">
                <div className="topbar__row">
                    {/* {linksList} */}
                    <div className="topbar__spring" />
                    <div className="topbar__item">
                        <Dropdown
                            title={<b>{username}</b>}
                            items={accountLinks}
                        />
                    </div>                                              
                </div>
            </div>
        </div>
    );

}



export default Topbar;